import parsePhoneNumberFromString, { AsYouType } from "libphonenumber-js"

export function onlyDigits(value) {
  for (let i = value.length - 1; i >= 0; i--) {
    const d = value.charCodeAt(i);

    if (d < 48 || d > 57)
      return false
  }

  return true
}

export function cpfMask(value) {
  return value
    .replace(/\D/g, '') // substitui qualquer caracter que nao seja numero por nada
    .replace(/(\d{3})(\d)/, '$1.$2') // captura 2 grupos de numero o primeiro de 3 e o segundo de 1, apos capturar o primeiro grupo ele adiciona um ponto antes do segundo grupo de numero
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d{1,2})/, '$1-$2')
    .replace(/(-\d{2})\d+?$/, '$1') // captura 2 numeros seguidos de um traço e não deixa ser digitado mais nada
}

export function cnpjMask(value) {
  return value
    .replace(/\D/g, '') // substitui qualquer caracter que nao seja numero por nada
    .replace(/(\d{2})(\d)/, '$1.$2') // captura 2 grupos de numero o primeiro de 3 e o segundo de 1, apos capturar o primeiro grupo ele adiciona um ponto antes do segundo grupo de numero
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{3})(\d)/, '$1.$2')
    .replace(/(\d{4})(\d{1,2})/, '$1/$2')
    .replace(/(\/\d{2})\d+?$/, '$1') // captura 2 numeros seguidos de um traço e não deixa ser digitado mais nada
}

/*
 * Formats a phone number as the user types (Brazilian pattern).
 *
 * Example:
 *  telephoneMask("54999887766") -> "(54) 99988-7766"
 *  telephoneMask("1133445566")  -> "(11) 3344-5566"
 */
export function telephoneMask(value = "") {
  return new AsYouType("BR").input(value.replace(/\D/g, ""))
}

/*
 * Formats a phone number (Brazilian format) for display purposes.
 * This function should be used when rendering data (tables, reports, CRM),
 * 
 * Example:
 *  formatPhone("54999887766")   -> "(54) 99988-7766"
 *  formatPhone("+554999887766") -> "(54) 99988-7766"
 */
export function formatPhone(value) {
  if (!value || value === '-') return "-"

  const digits = value.replace(/\D/g, "")

  try {
    const phone = parsePhoneNumberFromString(digits, "BR")
    return phone?.formatNational() ?? value
  } catch {
    return value
  }
}

/*
 * Capitalizes the first letter of each word in a string.
 *
 * Example:
 *  capitalizeEachWord("jOÃO dA siLVA") -> "João Da Silva"
 */
export function capitalizeEachWord(string) {
  return string
    .toLowerCase()
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
}